import { IconZoomScan } from "@tabler/icons-react";
import { Link, useCanGoBack, useRouter } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import {
	Empty,
	EmptyContent,
	EmptyDescription,
	EmptyHeader,
	EmptyMedia,
	EmptyTitle,
} from "@/components/ui/empty";

export function NotFound({ children }: { children?: ReactNode }) {
	const router = useRouter();
	const canGoBack = useCanGoBack();

	return (
		<div className="flex flex-1 items-center justify-center p-4">
			<Empty className="w-full">
				<EmptyHeader>
					<EmptyMedia variant="icon" className="bg-destructive/5 text-destructive">
						<IconZoomScan />
					</EmptyMedia>
					<EmptyTitle>Page Not Found</EmptyTitle>
					<EmptyDescription>
						The page you are looking for does not exist. It might have been removed or you may have
						entered an incorrect URL.
					</EmptyDescription>
				</EmptyHeader>
				{children}
				<EmptyContent className="flex-row justify-center">
					<Button variant="outline" size="sm" onClick={() => router.invalidate()}>
						Try Again
					</Button>
					{canGoBack ? (
						<Button variant="outline" size="sm" onClick={() => router.history.back()}>
							Back
						</Button>
					) : null}
					<Button
						variant="outline"
						size="sm"
						nativeButton={false}
						render={<Link to="/">Go to homepage</Link>}
					/>
				</EmptyContent>
			</Empty>
		</div>
	);
}
